import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import AdminOverviewDashboard from "./AdminOverviewDashboard";
import DistributorOverviewDashboard from "./DistributorOverviewDashboard";
import SalesOverviewDashboard from "./SalesOverviewDashboard";
import SalesHeadDashboard from "./SalesHead";
import OpsOverviewDashboard from "./OpsOverviewDashboard";
import ApproverPage from "./ApproverPage";

/**
 * Role-based dashboard router.
 * Reads `user_details` from localStorage and renders the
 * appropriate dashboard component based on `role_id`.
 *
 * Role mapping:
 *   1  (ADMIN)          → AdminOverviewDashboard
 *   2  (DISTRIBUTOR)    → DistributorDashboard
 *   3  (OPS/AMC)        → OpsOverviewDashboard
 *   7  (SALES)          → SalesOverviewDashboard
 *   8  (SALES_HEAD)     → SalesHeadDashboard
 */
const DashboardPage = () => {
  const navigate = useNavigate();

  const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");
  const userId = userDetails?.id || null;

  // Get role_id (numeric) and role name (string)
  const roleId = Number(userDetails?.role_id);
  const roleName = (userDetails?.role_name || userDetails?.role || "").toUpperCase();

  useEffect(() => {
    if (!userId) {
      navigate("/", { replace: true });
    }
  }, [userId, navigate]);

  if (!userId) return null;

  // 1. Primary check by role_id
  if (roleId === 1) return <AdminOverviewDashboard />;
  if (roleId === 2) return <DistributorOverviewDashboard />;
  if (roleId === 3) return <OpsOverviewDashboard />;
  if (roleId === 7) return <SalesOverviewDashboard />;
  if (roleId === 8) return <SalesHeadDashboard />;

  // 2. Fallback check by role string (role_name or role)
  if (roleName.includes("ADMIN")) return <AdminOverviewDashboard />;
  if (roleName.includes("DISTRIBUTOR")) return <DistributorOverviewDashboard />;
  if (roleName.includes("SALES_HEAD")) return <SalesHeadDashboard />;
  if (roleName.includes("SALES")) return <SalesOverviewDashboard />;
  if (roleName.includes("OPS") || roleName.includes("AMC")) return <OpsOverviewDashboard />;

  // 3. Default fallback
  return <AdminOverviewDashboard />;
};

export default DashboardPage;
